// What the app says when the account has reached a limit (David, 31 Oct): one short line, once a day on each device,
// and the same line in Settings, Account.
import { PLAN, countWords } from "../../shared/limits";
import type { Limits, Usage } from "../../shared/types";

/** The line for a board slowed past the month's writes: background work waits, the user's own edits save. */
export const slowedLine = () => `Agents, scripts and sources are slowed until tomorrow: this month's writes passed ${countWords(PLAN.writesPerMonth)}. Your own edits still save.`;

/** The one line to show for the account's limits now, or null: slowed first, then the day's source reads. */
export function limitLine(usage: Usage | null | undefined, limits: Limits | null | undefined): string | null {
  if (!usage) return null;
  if (usage.slowed) return slowedLine();
  const reads = limits?.pullsPerDay;
  if (reads && usage.pulls >= reads) return `Sources have refreshed ${countWords(reads)} times today, the daily limit, so they wait until midnight UTC.`;
  return null;
}
